module.exports = require("@wel-ui/component-group");



//////////////////
// WEBPACK FOOTER
// ../node_modules/@wel-ui/components/Group/index.js
// module id = 154
// module chunks = 0